'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import ServiceTitleForm from 'Components/Forms/Models/ServiceTitle/ServiceTitleForm';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { front_urls, URL } from 'Shared/Routes';
let app = window.app;
export default class NewServiceTitlePage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Nouveau titre"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/React.createElement(Button, {
      component: Link,
      href: URL('AdminServiceTitlesDashboard', front_urls),
      className: bemit('c-flat-btn') + ' u-margin-bottom-15'
    }, '<', " Retour aux titres"), /*#__PURE__*/React.createElement(ServiceTitleForm, null)));
    return output;
  }
}
